<template>
  <AdminShell
    :page-title="pageTitle"
    :page-subtitle="pageSubtitle"
    active-menu="control"
    :hide-hero="joined"
  >
  <div class="streamer">
    <div class="streaming-container">
      <div class="video-container">
        <!-- <video id="videoContent" ref="videoContent" autoplay muted playsinline></video> -->
        <div ref="localPlayer" id="localPlayer" class="player"></div>
        <template v-if="joined">
          <div class="livedata-tips" @click="showLiveData = !showLiveData">
            <span class="net-indicator" :class="[net_status_lights]"></span>直播数据
          </div>

          <div class="livedata-container" v-if="showLiveData">
            <div>
              <div>上行码率(kbps)</div>
              <div>{{ PushStats.uplinkKbps }}</div>
            </div>
            <div>
              <div>下行码率(kbps)</div>
              <div>{{ PushStats.downlinkKbps }}</div>
            </div>
            <div>
              <div>RTT(ms)</div>
              <div>{{ PushStats.rttMs }}</div>
            </div>
            <div>
              <div>上行丢包(%)</div>
              <div>{{ PushStats.uplinkLossPct }}</div>
            </div>
            <div>
              <div>下行丢包(%)</div>
              <div>{{ PushStats.downlinkLossPct }}</div>
            </div>
            <div>
              <div>视频FPS</div>
              <div>{{ PushStats.videoFps }}</div>
            </div>
            <div>
              <div>发送分辨率</div>
              <div>{{ PushStats.videoResolution }}</div>
            </div>
            <div>
              <div>网络质量(上/下)</div>
              <div>{{ PushStats.uplinkNQ }}/{{ PushStats.downlinkNQ }}</div>
            </div>
          </div>

          <div class="live-indicator">
            <div class="live-status">直播中</div>
          </div>

          <div class="right-menu">
            <span class="viewer-count">{{ online_count }} 人在线</span>
            <span class="icon" @click="endLiveHandle">
              <img src="../assets/close.svg" alt="" style="width: 25px;height: 25px;">
            </span>
          </div>

          <div class="switch-icon">
            <span class="icon" @click="switchCamera">
              <img src="../assets/camera.svg" alt="" />
            </span>
          </div>
          <div class="chat-container" v-if="roomId">
            <DanmakuPanel url="wss://danmuadmin.wokfoy.com:9981/b" :room-id="danmu_roomId" :token="token">
              <template v-slot:default>
                <span class="icon" @click="swicthAudioTrack">
                  <img v-if="isMicOn" src="../assets/mic-on.svg" alt="" style="width: 35px; height: 35px" />
                  <img v-else src="../assets/mic-off.svg" alt="" style="width: 35px; height: 35px" />
                </span>
                <span class="icon">
                  <img src="../assets/facebook.png" style="width: 35px; height: 35px" />
                </span>
                <chatWidget></chatWidget>
              </template>
            </DanmakuPanel>
          </div>
        </template>

        <template v-else>
          <div class="live-menu-top">
            <div class="live-info">
              <router-link to="/">
                <span class="icon">
                  <img src="../assets/arrow-left.svg" alt="">
                </span>
              </router-link>
              <span class="liver-avatar">G</span>
              <span>Green bag store</span>
            </div>
            <div class="media-setting">
              <span></span>
              <span class="button-icon" @click="switchCamera">
                <img src="../assets/camera.svg" alt="" />
              </span>
              <span class="button-icon" @click="swicthAudioTrack">
                <img v-if="isMicOn" src="../assets/mic-on.svg" alt="" />
                <img v-else src="../assets/mic-off.svg" alt="" />
              </span>
            </div>
          </div>

          <div class="live-menu-bottom">
            <input type="text" placeholder="直播主题，开启直播" class="live-title-input" v-model="liveTitle" />
            <button @click="goLive">开始直播</button>
          </div>
        </template>


        <div v-if="cameraPickerVisible" class="camera-picker-mask" @click="closeCameraPicker">
          <div class="camera-picker-sheet" @click.stop>
            <div class="camera-picker-title">选择摄像头</div>
            <div v-for="cam in cameraOptions" :key="cam.deviceId" class="camera-picker-item"
              :class="{ active: cam.deviceId === currentCamId }" @click="selectCamera(cam)">
              <span>{{ cam.label || '未命名摄像头' }}</span>
              <span v-if="cam.deviceId === currentCamId">✓</span>
            </div>
            <div class="camera-picker-cancel" @click="closeCameraPicker">取消</div>
          </div>
        </div>

        <Countdown321 ref="countdown" :size="240" color="#ccc" @finished="onFinished" />
        <!-- <div class="countdown-box" v-show="restartComfirm">
          <div>{{ restartTime + 's后将关闭直播' }}</div>
          <div class="countdown-btn" style="background-color:aquamarine;" @click="initRestartTimer">恢复直播</div>
          <div class="countdown-btn" style="background-color: #ff0000;" @click="endLiveHandle">关闭直播</div>
        </div> -->
      </div>
    </div>
  </div>
  </AdminShell>
</template>

<script>
import AdminShell from '@/components/admin/AdminShell.vue'
import { getAppid, createStream, changeLiveStatus, getLiveData, liveroomsList } from '../api/index'
import DanmakuPanel from '../components/Danmaku.vue'
import {
  formatTime,
  preferMobileH264,
  forceH264Baseline,
  preferOpus,
  setKeepLive,
  getKeepLive,
  clearKeepLive,
} from '../utils/common'
import { normalizeAgoraJoinUid, requestAgoraRtcToken } from '../utils/agora-token'
import { getToken } from '../utils/auth'
import Countdown321 from "../components/countdown321.vue";
import chatWidget from "../components/chat.vue";
import AgoraRTC from 'agora-rtc-sdk-ng';


function calcNetQuality(stats) {
  const {
    uplinkKbps = 0,
    rttMs = 0,
    uplinkLossPct = 0,
    videoFps = 0,
    uplinkNQ = 6,
  } = stats;
  // 红
  if (
    uplinkKbps < 600 ||
    rttMs > 400 ||
    uplinkLossPct > 5 ||
    videoFps < 15 ||
    uplinkNQ >= 4
  ) {
    return "bad"; // 🔴
  }

  // 黄
  if (
    uplinkKbps < 1200 ||
    rttMs > 200 ||
    uplinkLossPct >= 1 ||
    videoFps < 20 ||
    uplinkNQ === 3
  ) {
    return "warn"; // 🟡
  }

  return "good"; // 🟢
}

export default {
  name: 'Streamer',
  components: { AdminShell, DanmakuPanel, Countdown321, chatWidget },
  data() {
    return {
      pageTitle: '\u76f4\u64ad\u4e2d\u63a7',
      pageSubtitle: '\u7ba1\u7406\u63a8\u6d41\u9884\u89c8\u3001\u5f00\u64ad\u64cd\u4f5c\u4e0e\u76f4\u64ad\u4e2d\u72b6\u6001\u3002',
      roomId: '',
      danmu_roomId: '',
      chatInput: '',
      loading: false,
      isStreaming: false,

      // 本地媒体流（注意：只保留一处声明，避免重复）
      stream: null,

      openAudioTrack: true,
      pushing: false,
      state: '',
      liveTitle: 'Green bag Store',

      // 会话持久化
      sessionKey: 'bitlive_push_session_v1',
      userTerminated: false,

      // 设备
      videoInputs: [],
      audioInputs: [],
      selectedCam: '',
      selectedMic: '',
      resolution: 720,
      fps: 30,
      kbps: 2000,
      audioKbps: 64,
      noiseSuppression: true,
      echoCancellation: true,
      autoGain: false,

      // WebRTC
      currentFacing: 'user',
      frontCamId: null,
      backCamId: null,
      pc: null,
      videoSender: null,
      audioSender: null,
      statsTimer: null,

      // 防并发/竞态
      startToken: 0,

      // WHIP
      whipUrl: '/whip',
      auth: '', // webrtc://...
      whipResource: '',
      _whipInFlight: false,
      _whipCompleted: false,

      // ICE
      iceText: 'stun:stun.l.google.com:19302',
      forceRelay: true,

      // 直播数据
      visitDataTimer: null,
      showLiveData: false,
      LiveData: {
        enterCount: 88,
        timeCount: 88,
        commentCount: 88,
        redirectCount: 11
      },
      online_count: 0,

      // 稳态
      retryTimer: null,
      retryCount: 0,
      maxRetry: 6,
      baseBackoffMs: 1200,
      lastGoodBitrateTs: 0,
      zeroBitrateSince: 0,
      appid: 1,

      restartComfirm: false,
      restartTime: 120,
      restartTimer: null,

      // Agora相关
      appId: '656131426d3845acadd7c7e18bf2e19a',
      channel: 'Green Bud Store',
      uidInput: '',
      hostUid: '',
      uidMode: '',
      agoraToken: '',
      client: null,
      localAudioTrack: null,
      localVideoTrack: null,
      joined: false,
      published: false,
      previewReady: false,
      loadingToken: false,
      tokenServer: process.env.NODE_ENV === "production" ? 'https://streamer.wokfoy.com/rtcToken' : '/rtcToken',
      cameras: [],            // 摄像头列表
      currentCamId: null,     // 当前使用的摄像头 deviceId
      cameraPickerVisible: false,
      isBackCamera: true,
      mics: [],            // 可用麦克风列表
      currentMicId: null,  // 当前使用的麦克风 deviceId
      isMicOn: true,
      autoReconnectEnabled: true,   // 是否开启自动重连（用户主动停止时会关掉）
      _reconnecting: false,         // 当前是否在重连中
      _reconnectAttempts: 0,        // 重试次数

      _refreshingTokenPromise: null,
      _lastRenewAt: 0,

      _tokenFatalHandling: false,     // 是否已经进入“token不可恢复”流程
      _tokenExpireModalShown: false,  // 是否已经弹窗过
      _tokenRefreshTimer: null,
      PushStats: {
        uplinkKbps: 0,
        downlinkKbps: 0,
        rttMs: 0,
        uplinkLossPct: 0,
        downlinkLossPct: 0,
        videoFps: 0,
        videoResolution: '--',
        uplinkNQ: 0,
        downlinkNQ: 0,
        updatedAt: ''
      },
      net_status_lights: 'good',
      wokfoy_appid: 0,
    }
  },
  computed: {
    token() {
      return this.$store.getters.token || localStorage.getItem('lvtu_live_apitoken') || getToken()
    },
    cameraOptions() {
      return (this.cameras || []).filter(cam => cam && cam.deviceId)
    },
  },
  async mounted() {
    let { data: apps } = await getAppid()
    this.wokfoy_appid = apps[0].id
    await this.startPreview()
    // 进入页面尝试自动续推
    this.autoResume();
  },
  beforeDestroy() {
    this.cameraPickerVisible = false;
    if (this.joined) this.leave();
  },
  methods: {
    async fetchToken() {
      if (!this.tokenServer) {
        alert('未配置 Token 服务：请在 tokenServer 中填入你的服务地址或设置 VUE_APP_TOKEN_SERVER');
        throw new Error('token server missing');
      }
      this.loadingToken = true;
      try {
        const tokenData = await requestAgoraRtcToken({
          tokenServer: this.tokenServer,
          channel: this.channel,
          role: 'publisher',
          uid: this.hostUid || this.uidInput,
        });
        this.applyAgoraTokenState(tokenData);
        return tokenData;
      } catch (e) {
        this.agoraToken = '';
        console.error(e);
        alert('获取 Token 失败');
        throw e;
      } finally {
        this.loadingToken = false;
      }
    },
    async startPreview() {
      await this._ensureCameras()

      const preferredCamera = this._pickPreferredCamera(this.cameras)

      try {
        if (!this.localVideoTrack) {
          this.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
            encoderConfig: {
              width: 1080,
              height: 1920,
              frameRate: 20,
              bitrateMin: 1000,
              bitrateMax: 3000,
            },
            optimizationMode: 'motion',
            cameraId: preferredCamera?.deviceId
          })
        }

        const settings = this.localVideoTrack.getMediaStreamTrack().getSettings?.()
        this.currentCamId = settings?.deviceId || preferredCamera?.deviceId || null
        this.isBackCamera = this._isBackCameraByLabel(
          this.cameras.find(d => d.deviceId === this.currentCamId)?.label
        )
      } catch (e) {
        console.warn('[agora] 默认镜头创建失败，尝试兜底：', e)
        const fallbackCamera = preferredCamera || this.cameras[0]
        this.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
          encoderConfig: {
            width: 1080,
            height: 1920,
            frameRate: 20,
            bitrateMin: 1000,
            bitrateMax: 3000,
          },
          optimizationMode: 'motion',
          cameraId: fallbackCamera?.deviceId
        })
        this.currentCamId = fallbackCamera?.deviceId || null
        this.isBackCamera = this._isBackCameraByLabel(fallbackCamera?.label)
      }

      if (!this.localAudioTrack) {
        this.mics = await AgoraRTC.getMicrophones().catch(() => [])

        this.localAudioTrack = await AgoraRTC.createMicrophoneAudioTrack({
          AEC: true,
          ANS: true,
          AGC: true,
          microphoneId: this.currentMicId || undefined
        })

        const settings = this.localAudioTrack.getMediaStreamTrack().getSettings?.()
        this.currentMicId = settings?.deviceId || this.mics[0]?.deviceId || null

        this.isMicOn = true
      }

      this.localVideoTrack.play(this.$refs.localPlayer, { mirror: false })
      this.previewReady = true
    },

    // 停止预览（不影响房间状态）
    async stopPreview() {
      try {
        if (this.localAudioTrack) { this.localAudioTrack.close(); this.localAudioTrack = null; }
        if (this.localVideoTrack) { this.localVideoTrack.close(); this.localVideoTrack = null; }
        if (this.$refs.localPlayer) this.$refs.localPlayer.innerHTML = '';
        this.previewReady = false;
      } catch (e) {
        console.error(e);
      }
    },
    async joinAndPublish() {
      try {
        if (!this.client) {
          this.client = AgoraRTC.createClient({ mode: 'live', codec: 'h264' });
          await this.client.setClientRole('host');
          this._bindClientEvents();               // 绑定事件（见下）
        }

        // 如果未预览，先预览
        if (!this.previewReady) await this.startPreview();

        // 固定 uid；没有就让 SDK 随机（不推荐）
        const uid = this.getAgoraJoinUid();
        this.hostUid = this.hostUid || this.uidInput;



        const realUid = await this.client.join(this.appId, this.channel, this.agoraToken || null, uid);
        if (!this.hostUid && realUid != null) {
          this.hostUid = String(realUid);
          this.uidInput = String(realUid);
        }
        this.client.setLowStreamParameter({
          width: 360,
          height: 640,
          framerate: 15,
          bitrate: 800,
        });
        await this.client.enableDualStream();
        this.joined = true;

        await this._safePublish();                 // 发布本地轨
      } catch (e) {
        console.error('joinAndPublish err', e);
        // alert('Join/Publish 失败：' + (e?.message || e));
      }
    },
    async _safePublish() {
      if (!this.client) {
        console.warn('[publish] no client');
        return;
      }
      if (!this.localVideoTrack || !this.localAudioTrack) {
        console.warn('[publish] missing tracks', {
          video: !!this.localVideoTrack,
          audio: !!this.localAudioTrack
        });
        return;
      }
      if (this.published) {
        console.log('[publish] already published');
        return;
      }

      await this.client.publish([this.localAudioTrack, this.localVideoTrack]);
      this.published = true;
      console.log('publish success');
      this._startPushStatsMonitor();
    },

    async _safeUnpublish() {
      if (!this.client || !this.published) return;
      try { await this.client.unpublish(); } catch { }
      this.published = false;
      this._stopPushStatsMonitor();
    },

    _bindClientEvents() {
      // 连接状态变化：掉线->重连->重发
      this.client.on('connection-state-change', async (cur, prev, reason) => {
        console.warn('[conn]', prev, '=>', cur, 'reason:', reason);
        if (!this.autoReconnectEnabled) return;
        if (cur === 'RECONNECTING') {
          this.reconnecting = true;
        } else if (prev === 'RECONNECTING' && cur === 'CONNECTED') {
          this.reconnecting = false;
          // 重连成功后，确保已发布
          await this._safePublish();
        } else if (cur === 'DISCONNECTED') {
          // 可选：断开时清标记，等待 SDK 自动重连
          this.published = false;
        }
      });

      // Token 续期
      this.client.on('token-privilege-will-expire', async () => {
        console.warn('[token] will expire');
        if (this._tokenFatalHandling) return;

        try {
          await this._renewAgoraTokenSafely('publisher');
        } catch (e) {
          console.error('[token] will-expire renew failed', e);

          // ✅ 这里建议直接进入“不可恢复”处理（或允许再重试一次后再进）
          await this._handleTokenExpiredFatal(e?.message || 'will-expire renew failed');
        }
      });

      this.client.on('token-privilege-did-expire', async () => {
        console.warn('[token] did expire');
        if (this._tokenFatalHandling) return;

        // 这里：先尽力续一次（你现在已有 refresh + renew）
        try {
          await this._renewAgoraTokenSafely('publisher'); // 你可以按我上次给你的重试版实现
          console.warn('[token] did-expire renew success');
        } catch (e) {
          console.error('[token] did-expire renew failed => fatal', e);

          // ✅ 确认无法续期 => 弹窗提示 + 下播
          await this._handleTokenExpiredFatal(e?.message || 'renew token failed');
        }
      });

      // ===== 实时推流/网络指标（用于调试）=====
      // rtc-stats：RTT / 收发码率（kbps）
      // rtc-stats 事件在部分构建/版本中可能不会触发；这里改用 getRTCStats()/track.getStats() 定时拉取（见 _startPushStatsMonitor）。

      // local-video-stats：发送 FPS / 分辨率 / 丢包（字段按版本容错）
      this.client.on('local-video-stats', (s) => {
        const fps = s.sendFrameRate ?? s.SendFrameRate ?? s.captureFrameRate ?? 0;

        const w = s.sendResolutionWidth ?? s.captureResolutionWidth ?? s.encodedFrameWidth ?? 0;
        const h = s.sendResolutionHeight ?? s.captureResolutionHeight ?? s.encodedFrameHeight ?? 0;

        // 部分版本提供 sendPacketLossRate(0~1)，部分提供 sendPacketLossRate(0~100)，做统一
        let loss = s.sendPacketLossRate ?? s.SendPacketLossRate;
        if (typeof loss === 'number') {
          if (loss <= 1) loss = loss * 100;
          this.PushStats.uplinkLossPct = Math.round(loss * 10) / 10;
        }

        this.PushStats.videoFps = Math.round(fps || 0);
        this.PushStats.videoResolution = (w && h) ? `${w}x${h}` : this.PushStats.videoResolution;
        this.PushStats.updatedAt = new Date().toLocaleTimeString();
      });

      // local-audio-stats：补充上行丢包（如视频 stats 不含）
      this.client.on('local-audio-stats', (s) => {
        let loss = s.sendPacketLossRate ?? s.SendPacketLossRate;
        if (typeof loss === 'number') {
          if (loss <= 1) loss = loss * 100;
          // 如果 video 没更新到，就用 audio 的
          if (!this.PushStats.uplinkLossPct) {
            this.PushStats.uplinkLossPct = Math.round(loss * 10) / 10;
          }
        }
      });

      // network-quality：上下行网络质量（0~6）
      this.client.on('network-quality', (q) => {
        this.PushStats.uplinkNQ = q.uplinkNetworkQuality ?? 0;
        this.PushStats.downlinkNQ = q.downlinkNetworkQuality ?? 0;
        this.PushStats.updatedAt = new Date().toLocaleTimeString();
      });

    },

    _startPushStatsMonitor() {
      // 定时拉取推流关键指标（兼容：部分 SDK 构建不会触发 rtc-stats 事件）
      try { if (this.statsTimer) clearInterval(this.statsTimer); } catch { }
      this.statsTimer = setInterval(async () => {
        if (!this.client || !this.published) return;

        // 1) RTC 级别统计
        try {
          const rtc = await (this.client.getRTCStats ? this.client.getRTCStats() : null);
          if (rtc) {
            const send = rtc.SendBitrate ?? rtc.sendBitrate ?? 0;   // kbps
            const recv = rtc.RecvBitrate ?? rtc.recvBitrate ?? 0;   // kbps
            const rtt = rtc.RTT ?? rtc.rtt ?? 0;                   // ms（部分版本为 RTT）
            const uploss = rtc.SendPacketLossRate ?? rtc.sendPacketLossRate ?? rtc.SendPacketLoss ?? 0; // %
            const dloss = rtc.RecvPacketLossRate ?? rtc.recvPacketLossRate ?? rtc.RecvPacketLoss ?? 0; // %

            this.PushStats.uplinkKbps = Math.round(send / 1000 || 0);
            this.PushStats.downlinkKbps = Math.round(recv || 0);
            this.PushStats.rttMs = Math.round(rtt || 0);

            // 有的版本返回的是 0~1 小数，有的返回 0~100
            const normPct = (v) => {
              if (typeof v !== 'number') return 0;
              if (v <= 1) return v * 100;
              return v;
            };
            this.PushStats.uplinkLossPct = Math.round(normPct(uploss));
            this.PushStats.downlinkLossPct = Math.round(normPct(dloss));
          }
          this.net_status_lights = calcNetQuality({ ...this.PushStats })
          console.log(this.net_status_lights)
        } catch (e) {
          // 忽略：有些版本不支持 getRTCStats 或会抛错
        }

        // 2) 本地视频轨统计（FPS/分辨率等）
        try {
          const vs = await (this.localVideoTrack?.getStats ? this.localVideoTrack.getStats() : null);
          if (vs) {
            const fps = vs.sendFrameRate ?? vs.sendFrameRateFps ?? vs.encodeFrameRate ?? 0;
            const w = vs.sendResolutionWidth ?? vs.sendResolution?.width ?? vs.captureResolutionWidth ?? 0;
            const h = vs.sendResolutionHeight ?? vs.sendResolution?.height ?? vs.captureResolutionHeight ?? 0;
            this.PushStats.videoFps = Math.round(fps || 0);
            this.PushStats.videoResolution = (w && h) ? `${w}x${h}` : this.PushStats.videoResolution;
          }
        } catch { }

        this.PushStats.updatedAt = new Date().toLocaleTimeString();
      }, 1000);
    },

    _stopPushStatsMonitor() {
      try { if (this.statsTimer) clearInterval(this.statsTimer); } catch { }
      this.statsTimer = null;
    },

    async leave() {
      try {
        await this._safeUnpublish();
        if (this.client) { await this.client.leave(); this.client = null; }
        await this.stopPreview();
        this.joined = false;
      } catch (e) { console.error(e); }
    },

    async _refreshToken(role = 'publisher') {
      try {
        // 用固定 uid 去拿 token，避免 uid 冲突
        const tokenData = await requestAgoraRtcToken({
          tokenServer: this.tokenServer,
          channel: this.channel,
          role,
          uid: this.hostUid || this.uidInput,
        });
        this.applyAgoraTokenState(tokenData);
        return this.agoraToken;
      } catch (e) {
        console.error('[refresh token] fail', e);
        throw e;
      }
    },
    async _refreshTokenLocked(role = 'publisher') {
      // 防抖：比如 2 秒内不重复 renew
      const now = Date.now();
      if (now - this._lastRenewAt < 2000 && this.agoraToken) return this.agoraToken;

      if (this._refreshingTokenPromise) return this._refreshingTokenPromise;

      this._refreshingTokenPromise = (async () => {
        await this._refreshToken(role);
        this._lastRenewAt = Date.now();
        return this.agoraToken;
      })();

      try {
        return await this._refreshingTokenPromise;
      } finally {
        this._refreshingTokenPromise = null;
      }
    },
    async _sleep(ms) { return new Promise(r => setTimeout(r, ms)); },

    async _refreshTokenWithRetry(role = 'publisher', maxRetry = 3) {
      let lastErr;
      for (let i = 0; i < maxRetry; i++) {
        try {
          await this._refreshToken(role); // 你现有方法
          if (!this.agoraToken) throw new Error('token empty');
          return this.agoraToken;
        } catch (e) {
          lastErr = e;
          await this._sleep(300 * Math.pow(2, i));
        }
      }
      throw lastErr;
    },

    async _renewAgoraTokenSafely(role = 'publisher') {
      // 防止“致命流程”中仍然有 renew
      if (this._tokenFatalHandling) throw new Error('token fatal handling');

      // 先获取新 token（带重试）
      const token = await this._refreshTokenWithRetry(role, 3);

      // renewToken 也重试（每次失败都重新获取 token）
      let lastErr;
      for (let i = 0; i < 3; i++) {
        try {
          await this.client.renewToken(token);
          return true;
        } catch (e) {
          lastErr = e;
          await this._sleep(200 * Math.pow(2, i));
          await this._refreshTokenWithRetry(role, 2);
        }
      }
      throw lastErr;
    },
    applyAgoraTokenState(tokenData = {}) {
      this.agoraToken = tokenData.token || '';
      if (tokenData.appId) this.appId = tokenData.appId;
      if (tokenData.uid != null && String(tokenData.uid).trim() !== '') {
        const rawUid = String(tokenData.uid);
        this.hostUid = rawUid;
        this.uidInput = rawUid;
      }
      this.uidMode = tokenData.uidMode || '';
    },
    getAgoraJoinUid() {
      return normalizeAgoraJoinUid(this.hostUid || this.uidInput);
    },
    async autoResume() {
      let { data } = await liveroomsList(this.wokfoy_appid,15, 1)
      let living = data.data.find(f => f.status == 1)
      if (!living) return
      this.channel = living.stream_name
      try { await this.startPush(); } catch (_) { }
    },

    async switchCamera() {
      await this._ensureCameras()
      if (!this.cameras.length) return
      this.cameraPickerVisible = true
    },

    closeCameraPicker() {
      this.cameraPickerVisible = false
    },

    async selectCamera(cam) {
      if (!cam?.deviceId) return
      this.cameraPickerVisible = false
      if (cam.deviceId === this.currentCamId) return

      try {
        await this._switchToCamera(cam)
      } catch (err) {
        console.error('[agora] 选择摄像头失败：', err)
        alert('切换摄像头失败：' + (err?.message || err))
      }
    },

    async _ensureCameras() {
      if (!this.cameras.length) {
        this.cameras = await AgoraRTC.getCameras().catch(() => [])
      }
      return this.cameras
    },

    _pickPreferredCamera(cams = []) {
      if (!cams.length) return null
      return (
        cams.find(d => /后置超广角相机|ultra\s*-?\s*wide/i.test(d.label || '')) ||
        cams.find(d => /后置双广角镜头|dual\s*-?\s*wide/i.test(d.label || '')) ||
        cams.find(d => /后置三镜头|triple/i.test(d.label || '')) ||
        cams.find(d => /后置双镜头|dual/i.test(d.label || '')) ||
        cams.find(d => /后置相机|back|rear|environment/i.test(d.label || '')) ||
        cams[0]
      )
    },

    _isBackCameraByLabel(label = '') {
      return /后置|back|rear|environment/i.test(label || '')
    },

    async _switchToCamera(target) {
      const wasPublished = this.published

      try {
        await this.localVideoTrack.setDevice(target.deviceId)
        this.currentCamId = target.deviceId
        this.isBackCamera = this._isBackCameraByLabel(target.label)
        this.localVideoTrack.play(this.$refs.localPlayer, { fit: 'cover', mirror: false })
      } catch (err) {
        console.warn('[agora] setDevice 切换失败，尝试兜底重建轨：', err)
        await this._fallbackRecreateVideoTrack(target)
      }

      if (wasPublished && !this.published) {
        await this.client.publish(this.localVideoTrack)
        this.published = true
      }
    },

    async _fallbackRecreateVideoTrack(target) {
      const wasPublished = this.published

      if (wasPublished) {
        try { await this.client.unpublish(this.localVideoTrack) } catch (e) { }
        this.published = false
      }

      try { this.localVideoTrack?.stop() } catch (e) { }
      try { this.localVideoTrack?.close() } catch (e) { }

      this.localVideoTrack = await AgoraRTC.createCameraVideoTrack({
        encoderConfig: {
          width: 720,
          height: 1280,
          frameRate: 15,
          bitrateMin: 1000,
          bitrateMax: 3000,
        },
        optimizationMode: 'motion',
        cameraId: target?.deviceId
      })
      this.currentCamId = target?.deviceId || null
      this.isBackCamera = this._isBackCameraByLabel(target?.label)

      this.localVideoTrack.play(this.$refs.localPlayer, { fit: 'cover', mirror: false })

      if (wasPublished) {
        await this.client.publish(this.localVideoTrack)
        this.published = true
      }
    },

    async swicthAudioTrack() {
      if (!this.localAudioTrack) {
        // 如果还没有创建，补建一下
        await this.createDefaultMic()
        if (this.published) {
          await this.client.publish(this.localAudioTrack)
        }
        this.isMicOn = true
        return
      }

      this.isMicOn = !this.isMicOn
      await this.localAudioTrack.setEnabled(this.isMicOn)
    },

    async startPush(channel) {
      // 先保证本地有音视频轨道
      if (!this.localVideoTrack || !this.localAudioTrack) {
        await this.startPreview();   // 没有预览就先预览一次
      }

      let { data } = await liveroomsList(this.wokfoy_appid,5, 1)
      let living = data.data.find(f => f.status == 1)
      if (!living) {
        const { data } = await createStream({
          appid: this.wokfoy_appid,
          live_title: this.liveTitle,
          time_on: formatTime(Date.now() + 10000),
          time_out: formatTime(Date.now() + 3 * 24 * 60 * 60 * 1000)
        });
        this.roomId = data.stream_name || this.roomId;
        this.danmu_roomId = data.id
        this.channel = data.stream_name || this.roomId;
      } else {
        // ⭐ 已经有直播间时，明确同步 channel/roomId
        this.roomId = living.stream_name
        this.danmu_roomId = living.id
        this.channel = living.stream_name
      }

      await this.fetchToken()
      if (!this.agoraToken) return

      // 这里最好加 await，确保 join 完成
      try { await this.joinAndPublish() } catch (err) { }
      changeLiveStatus({appid:this.wokfoy_appid, stream_name: this.roomId || living.stream_name, stream_status: 1 });
    },
    async stopPush() {
      await this.leave()
      await this.startPreview()
    },
    async retryPush() {
      try {
        // 这里可以调用stopPush先清理资源，然后重新开始推流
        await this.stopPush();
        await this.startPush();  // 尝试重新开始推流
      } catch (err) {
        console.error('重试推流失败:', err);
        alert('重试推流失败，请稍后再试');
      }
    },

    async pullStatsWatchdog() {
      if (!this.pc) return;
      try {
        const report = await this.pc.getStats(null);
        let bytes = 0, ts = 0;
        report.forEach(s => {
          if (s.type === 'outbound-rtp' && !s.isRemote && (s.kind === 'video' || s.mediaType === 'video')) {
            if (typeof s.bytesSent === 'number' && typeof s.timestamp === 'number') {
              bytes = s.bytesSent; ts = s.timestamp;
            }
          }
        });
        if (!this._lastStat) this._lastStat = { bytes, ts };
        const deltaBytes = bytes - this._lastStat.bytes;
        const deltaMs = ts - this._lastStat.ts;
        this._lastStat = { bytes, ts };
        if (deltaMs > 0) {
          const bps = (deltaBytes * 8 * 1000) / deltaMs;
          this.bitrate = bps;
          const now = Date.now();
          if (bps > 1000) {
            this.lastGoodBitrateTs = now; this.zeroBitrateSince = 0;
          } else {
            if (!this.zeroBitrateSince) this.zeroBitrateSince = now;
            if (now - this.zeroBitrateSince > 8000) this.scheduleRestart('zero bitrate > 8s');
          }
        }
        try { this.videoSender?.requestKeyFrame?.(); } catch (_) { }
      } catch (_) { }
    },

    goLive() {
      if (!this.liveTitle) { alert('请先输入直播标题'); return; }
      // ✅ 提前声明用户意图：我要继续推（除非手动结束）
      this.$refs.countdown.start();
    },
    onFinished() {
      this.startPush();
    },
    async endLiveHandle() {
      if (!confirm('确定要结束直播吗？')) return;

      try { await changeLiveStatus({appid:this.wokfoy_appid, stream_name: this.roomId, stream_status: 2 }); } catch (_) { }
      await this.stopPush();
    },

    async _handleTokenExpiredFatal(reason = '') {
      // 防止重复触发（did-expire 可能多次回调）
      if (this._tokenFatalHandling) return;
      this._tokenFatalHandling = true;

      // 防止任何续期定时器继续跑
      if (this._tokenRefreshTimer) {
        clearTimeout(this._tokenRefreshTimer);
        this._tokenRefreshTimer = null;
      }

      // 弹窗只弹一次
      if (!this._tokenExpireModalShown) {
        this._tokenExpireModalShown = true;
        try {
          window.alert(
            `直播鉴权已过期，无法自动续期。\n系统将为你自动下播。\n\n${reason ? `原因：${reason}` : ''}`
          );
        } catch (e) {
          // alert 出问题也不能阻止下播
          console.error('[token] alert failed', e);
        }
      }

      // 自动下播：优先走你现有的“结束直播/退出频道”逻辑
      try {
        await this._endLiveStreamDueToToken();
      } catch (e) {
        console.error('[token] end live failed', e);
        // 即使失败也要尽最大努力离开
        try { await this.client?.leave?.(); } catch (_) { }
      } finally {
        // 给 UI 一个明确状态
        this.isLive = false; // 你项目里如果不是这个字段，换成对应的
      }
    },

    async _endLiveStreamDueToToken() {
      // 这里你应该复用你已有的“下播”方法（如果有，比如 stopStreaming/endLive/leaveRoom）
      // 我先给一个通用版本：unpublish -> stop tracks -> leave

      const client = this.client;
      if (!client) return;

      try {
        // 如果你有 localTracks
        if (this.localAudioTrack) {
          try { await client.unpublish(this.localAudioTrack); } catch (_) { }
        }
        if (this.localVideoTrack) {
          try { await client.unpublish(this.localVideoTrack); } catch (_) { }
        }

        // stop & close 本地轨道
        if (this.localAudioTrack) {
          try { this.localAudioTrack.stop(); } catch (_) { }
          try { this.localAudioTrack.close(); } catch (_) { }
          this.localAudioTrack = null;
        }
        if (this.localVideoTrack) {
          try { this.localVideoTrack.stop(); } catch (_) { }
          try { this.localVideoTrack.close(); } catch (_) { }
          this.localVideoTrack = null;
        }

        // 退出频道
        try { await client.leave(); } catch (_) { }

        // 清理 remote users（如果你有维护）
        this.remoteUsers = [];
      } catch (e) {
        console.error('[token] _endLiveStreamDueToToken error', e);
        throw e;
      }
    },
  }
}
</script>

<style scoped>
.streamer {
  position: relative;
}

.streaming-container {
  width: 100%;
  position: relative;
}

.video-container {
  position: relative;
  width: 100%;
  min-height: 640px;
  height: calc(100vh - 180px);
  background: #000;
  overflow: hidden;
  border-radius: 28px;
}

.video-container .player {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-container video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  z-index: 100;
}

.live-indicator {
  position: absolute;
  top: 15px;
  left: 15px;
  display: flex;
  line-height: 100%;
}

.net-indicator {
  display: inline-block;
  width: 10px;
  height: 10px;
  border-radius: 999px;
  margin-right: 5px;
  animation: 2s linear 0.5s blinking;
}

@keyframes blinking {
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.6;
  }

  100% {
    opacity: 1
  }
}

.net-indicator.good {
  background: #2ecc71;
}

.net-indicator.warn {
  background: #f1c40f;
}

.net-indicator.bad {
  background: #e74c3c;
}

.live-indicator .live-status {
  background: #e74c3c;
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}

.right-menu {
  position: absolute;
  top: 15px;
  right: 15px;
  display: flex;
  align-items: center;
  line-height: 100%;
}

.viewer-count {
  background: rgba(0, 0, 0, .6);
  color: #fff;
  padding: 4px 10px;
  border-radius: 20px;
  font-size: 12px;
  margin-right: 10px;
}

.chat-container {
  position: absolute;
  bottom: 0px;
  left: 0;
  width: 100%;
  max-height: 60%;
  overflow-y: auto;
  font-size: 14px;
  display: flex;
  flex-direction: column-reverse;
}

.action-menu {
  position: absolute;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .2);
  z-index: 999;
  padding: 5px;
}

.livedata-tips {
  position: absolute;
  top: 50px;
  right: 0px;
  font-size: 12px;
  color: #fff;
  background: rgba(0, 0, 0, .3);
  border-bottom-left-radius: 5px;
  border-top-left-radius: 5px;
  padding: 5px 10px;
}

.livedata-container {
  display: flex;
  width: 80%;
  flex-wrap: wrap;
  justify-content: space-around;
  padding: 20px;
  color: #fff;
  position: absolute;
  top: 150px;
  left: 10%;
  animation: all .5s linear;
  background: rgba(0, 0, 0, .3);
  border-radius: 10px;
  font-size: 14px;
  text-align: center;
  line-height: 40px;
  gap: 20px;
}

.live-menu-top {
  position: absolute;
  top: 0;
  left: 0;
  padding: 15px 8px;
  width: 100%;
  color: #fff;
}

.live-info {
  display: flex;
  align-items: center;
}

.live-info .liver-avatar {
  width: 30px;
  height: 30px;
  display: inline-block;
  line-height: 30px;
  text-align: center;
  font-size: 20px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  border-radius: 50%;
  color: #fff;
  margin-right: 5px;
}

.media-setting {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 30px;
  padding: 20px;
}

.media-setting .button-icon img {
  width: 25px;
  height: 25px;
}

.live-menu-bottom {
  position: absolute;
  bottom: 50%;
  left: 0;
  padding: 10px;
  width: 100%;
  transform: translateY(50%);
}

.live-menu-bottom .live-title-input {
  border: none;
  background: transparent;
  color: #fff;
  font-size: 16px;
  width: 100%;
}

.live-menu-bottom .live-title-input::placeholder {
  color: #fff;
}

.live-menu-bottom button {
  width: 100%;
  height: 40px;
  border-radius: 8px;
  color: #fff;
  text-align: center;
  background-color: #195afc;
  font-size: 16px;
  font-weight: 600;
  border: none;
  margin-top: 20px;
}

.icon img {
  width: 25px;
  height: 25px;
}

.switch-icon {
  position: absolute;
  right: 10px;
  top: 100px;
}

.countdown-box {
  position: absolute;
  width: 50vw;
  padding: 20px;
  top: 50dvh;
  left: 25vw;
  border-radius: 5px;
  background-color: rgba(0, 0, 0, .2);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50%);
}

.countdown-box .countdown-btn {
  width: 80%;
  height: 30px;
  border-radius: 15px;
  font-size: 14px;
  line-height: 30px;
  text-align: center;
  color: #fff;
  margin-top: 10px;
}

.camera-picker-mask {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, .45);
  z-index: 9999;
  display: flex;
  align-items: flex-end;
}

.camera-picker-sheet {
  width: 100%;
  background: rgba(28, 28, 30, .98);
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
  padding: 12px 16px calc(env(safe-area-inset-bottom) + 12px);
  color: #fff;
  max-height: 60vh;
  overflow-y: auto;
}

.camera-picker-title {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 10px;
}

.camera-picker-item,
.camera-picker-cancel {
  min-height: 48px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 12px;
  border-radius: 10px;
  background: rgba(255, 255, 255, .06);
  margin-top: 8px;
  font-size: 15px;
  word-break: break-all;
}

.camera-picker-item.active {
  border: 1px solid rgba(25, 90, 252, .8);
}

.camera-picker-cancel {
  justify-content: center;
  margin-top: 12px;
}

@media (max-width: 768px) {
  .video-container {
    min-height: 520px;
    height: calc(100vh - 120px);
    border-radius: 20px;
  }

  .livedata-container {
    width: 90%;
    left: 5%;
  }

  .countdown-box {
    width: 86vw;
    left: 7vw;
  }
}
</style>
